'use client';
import React, { useState } from 'react';
import { Switch } from '@heroui/switch';
import MonthYearToggle from './month-year-toggle';
import ComparisonBars from './comparison-bars';
import SavingsInfo from './savings-info';
import useOfferComparisonStore, {
  selectSavingsAmount,
} from '../store/use-offer-comparison-store';
import StartBookingButton from './start-booking-button';
import { useTranslations } from 'next-intl';
import PriceInfo from './price-info';
import { PriceComparisonProps } from './price-comparison';

export default function ComparisonChart({
  isGermanCustomer,
}: PriceComparisonProps) {
  const [includeGridCosts, setIncludeGridCosts] = useState(false);
  const [isMonthlyRate, setIsMonthlyRate] = useState(false);
  const savings = useOfferComparisonStore(selectSavingsAmount);
  const t = useTranslations('priceComparison');

  return (
    <div>
      <div className="items-start flex flex-col">
        <div
          className={`flex flex-row w-full ${
            isGermanCustomer ? 'justify-end' : 'justify-between'
          } px-6`}
        >
          {!isGermanCustomer && (
            <Switch
              classNames={{
                wrapper: `border border-[var(--color-border-default)] ${includeGridCosts ? '!bg-[var(--color-action-primary)]' : 'bg-subtle'}`,
                thumb:
                  'outline outline-1 outline-[var(--color-border-default)]',
              }}
              onValueChange={(value) => setIncludeGridCosts(value)}
            >
              <p
                data-testid="price-comparison-include-grid-costs"
                className="text-[var(--color-text-subtle)] text-sm leading-[18px]"
              >
                {t('includeGridCosts')}
              </p>
            </Switch>
          )}
          <div className="hidden md:block">
            <MonthYearToggle setIsMonthlyRate={setIsMonthlyRate} />
          </div>
        </div>
      </div>
      <ComparisonBars
        includeGridCosts={includeGridCosts}
        isMonthlyRate={isMonthlyRate}
      />
      {savings != null && savings >= 12 && (
        <div className="block md:hidden">
          <SavingsInfo savings={savings} isMonthlyRate={isMonthlyRate} />
        </div>
      )}
      <div className="mx-4">
        <div className="block md:hidden my-6">
          <MonthYearToggle setIsMonthlyRate={setIsMonthlyRate} />
        </div>
      </div>
      <div className="md:space-y-0 md:flex flex-row mx-4 md:gap-x-4 md:justify-center">
        <PriceInfo />
        <div className="hidden md:block">
          <StartBookingButton testId="comparisonChartBookingButton" />
        </div>
      </div>
    </div>
  );
}
